enum LogSortColumn {
    Date,
    IP,
    Pseudonym
}

export { LogSortColumn };
